var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { LOYALTY_SUSPENSION_SOURCE } from 'src/app/shared/constants';
import { CaptainService } from 'src/app/captain.service';
import { AppConfigService } from 'src/app/appConfig.service';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
var RevokeSuspensionDialogComponent = /** @class */ (function () {
    function RevokeSuspensionDialogComponent(dialog, appConfigService, captainService, dialogRef, data) {
        var _this = this;
        this.dialog = dialog;
        this.appConfigService = appConfigService;
        this.captainService = captainService;
        this.dialogRef = dialogRef;
        this.data = data;
        this.serviceGroups = [];
        this.onProceed = function () {
            var _a = _this, selectedServiceGroup = _a.selectedServiceGroup, suspensionReason = _a.suspensionReason;
            if (!selectedServiceGroup || !suspensionReason) {
                _this.showReasonAlert = true;
            }
            else if (selectedServiceGroup && suspensionReason) {
                _this.showReasonAlert = false;
                var paramObj = {
                    serviceGroup: selectedServiceGroup.toLowerCase(),
                    suspensionReason: suspensionReason
                };
                _this.dialogRef.close(paramObj);
            }
        };
    }
    RevokeSuspensionDialogComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.appConfigService.getSuspensionConfig()];
                    case 1:
                        _a.suspensionConfig = _b.sent();
                        this.suspensionReasons = JSON.parse(this.suspensionConfig.revokeSuspensionReasons);
                        this.suspensionP0RevokeReasons = JSON.parse(this.suspensionConfig.revokeP0SuspensionReasons);
                        this.serviceGroups = this.data.serviceGroups;
                        this.suspensionPriority = this.data.suspensionPriority;
                        this.suspensionSource = this.data.suspensionSource || {};
                        this.generalRevokeAccess = this.data.generalRevokeAccess;
                        this.loyaltyRevokeAccess = this.data.loyaltyRevokeAccess;
                        this.suspendedReason = this.data.suspendedReason;
                        this.suspendedUntil = this.data.suspendedUntil;
                        this.hasP0SuspensionRevocationPermission = this.data.hasP0SuspensionRevocationPermission;
                        return [2 /*return*/];
                }
            });
        });
    };
    RevokeSuspensionDialogComponent.prototype.onNoClick = function () {
        this.dialogRef.close();
    };
    RevokeSuspensionDialogComponent.prototype.onServiceChange = function () {
        if (this.suspensionPriority[this.selectedServiceGroup] == 0) {
            this.filteredSuspensionReasons = this.suspensionP0RevokeReasons;
        }
        else {
            this.filteredSuspensionReasons = this.suspensionReasons;
        }
    };
    RevokeSuspensionDialogComponent.prototype.hasSuspensionRevokeAccess = function () {
        var source = this.suspensionSource[this.selectedServiceGroup] || '';
        var isLoyaltySuspension = source === LOYALTY_SUSPENSION_SOURCE;
        if (isLoyaltySuspension && !this.loyaltyRevokeAccess) {
            return false;
        }
        if (!isLoyaltySuspension && !this.generalRevokeAccess) {
            return false;
        }
        if (this.suspensionPriority[this.selectedServiceGroup] != 0) {
            return true;
        }
        return this.hasP0SuspensionRevocationPermission;
    };
    RevokeSuspensionDialogComponent.prototype.revokeSuspension = function () {
        var _this = this;
        if (!this.suspensionReason) {
            this.showReasonAlert = true;
            return;
        }
        this.showReasonAlert = false;
        var confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '335px',
            data: { title: 'Are you sure you want to revoke the suspension?',
                type: 'revoke',
                buttonText: 'Yes',
                reason: this.suspensionReason
            }
        });
        confirmDialogRef.afterClosed().subscribe(function (confirmResult) {
            if (confirmResult) {
                _this.onProceed();
            }
        });
    };
    return RevokeSuspensionDialogComponent;
}());
export { RevokeSuspensionDialogComponent };
